// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__RQw6s","menuList":"Navigation_menuList__l-9Gc","activeMenu":"Navigation_activeMenu__DI3gA","disabled":"Navigation_disabled__D8yLT"};